import React from 'react';
import { Button } from '@/components/ui/button';
import { Card, CardContent } from '@/components/ui/card';
import { CheckCircle, Users, Shield, TrendingUp } from 'lucide-react';
import { Link } from 'react-router-dom';

export const AboutPage = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      {/* Hero Section */}
      <section className="bg-gradient-to-br from-emerald-600 via-teal-600 to-cyan-600 text-white py-20">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8">
          <div className="max-w-3xl mx-auto text-center">
            <h1 className="text-4xl md:text-5xl font-bold mb-6" data-testid="about-heading">
              About Yalla ! Lets Save.
            </h1>
            <p className="text-xl text-emerald-50">
              UAE's trusted platform for discovering amazing deals and saving money across all seven emirates
            </p>
          </div>
        </div>
      </section>

      {/* Mission Section */}
      <section className="py-16 bg-white">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8">
          <div className="max-w-4xl mx-auto">
            <h2 className="text-3xl font-bold text-center mb-8">Our Mission</h2>
            <p className="text-lg text-gray-700 text-center mb-6">
              We believe everyone deserves to enjoy the best that the UAE has to offer without breaking the bank. 
              Our mission is to connect residents and visitors with verified deals and exclusive offers across 
              dining, shopping, entertainment, travel, and lifestyle experiences.
            </p>
            <p className="text-lg text-gray-700 text-center">
              Founded in 2025, Yalla ! Lets Save. was born from a simple idea: making savings accessible, 
              transparent, and rewarding for everyone in the UAE.
            </p>
          </div>
        </div>
      </section>

      {/* Values Section */}
      <section className="py-16 bg-gray-50">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-3xl font-bold text-center mb-12">Why Choose Us</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 max-w-6xl mx-auto">
            <Card>
              <CardContent className="p-6 text-center">
                <CheckCircle className="w-12 h-12 text-emerald-600 mx-auto mb-4" />
                <h3 className="text-xl font-semibold mb-3">Verified Deals</h3>
                <p className="text-gray-600">
                  Every deal is verified and updated daily to ensure you get what's promised
                </p>
              </CardContent>
            </Card>

            <Card>
              <CardContent className="p-6 text-center">
                <Shield className="w-12 h-12 text-emerald-600 mx-auto mb-4" />
                <h3 className="text-xl font-semibold mb-3">100% Free</h3>
                <p className="text-gray-600">
                  No subscription fees, no hidden charges. Completely free to use
                </p>
              </CardContent>
            </Card>

            <Card>
              <CardContent className="p-6 text-center">
                <Users className="w-12 h-12 text-emerald-600 mx-auto mb-4" />
                <h3 className="text-xl font-semibold mb-3">Community Driven</h3>
                <p className="text-gray-600">
                  Real reviews and ratings from our community of savvy savers
                </p>
              </CardContent>
            </Card>

            <Card>
              <CardContent className="p-6 text-center">
                <TrendingUp className="w-12 h-12 text-emerald-600 mx-auto mb-4" />
                <h3 className="text-xl font-semibold mb-3">UAE-Wide Coverage</h3>
                <p className="text-gray-600">
                  Deals across all seven emirates, from Dubai to Fujairah
                </p>
              </CardContent>
            </Card>
          </div>
        </div>
      </section>

      {/* Team Section */}
      <section className="py-16 bg-white">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8">
          <div className="max-w-4xl mx-auto text-center">
            <h2 className="text-3xl font-bold mb-6">Our Team</h2>
            <p className="text-lg text-gray-700 mb-8">
              We're a passionate team of deal hunters, tech enthusiasts, and UAE residents who understand 
              the importance of value for money. Our diverse backgrounds help us find and verify the best 
              deals across every category.
            </p>
            <p className="text-gray-600 italic">
              Based in Dubai, UAE | Founded 2025
            </p>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-16 bg-gradient-to-r from-emerald-600 to-teal-600 text-white">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-3xl font-bold mb-4">Ready to Start Saving?</h2>
          <p className="text-xl text-emerald-50 mb-8">
            Join thousands of smart savers across the UAE
          </p>
          <Link to="/">
            <Button size="lg" className="bg-white text-emerald-600 hover:bg-gray-100">
              Browse Deals Now
            </Button>
          </Link>
        </div>
      </section>
    </div>
  );
};